var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 13.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 13.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDots);
export default __webpack_public_path__ + "static/media/icon-dots.2f74311ee5a2eec6bb11889fc687e60d.svg";
export { ForwardRef as ReactComponent };